import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../app_components/Icon';
import { primitives } from '@lexody/design-tokens';

class VerifiedChip extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.wrapperRef = React.createRef();
    this.handleToggle = this.handleToggle.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleToggle() {
    this.setState((prev) => ({ open: !prev.open }));
  }

  handleClickOutside(event) {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
      this.setState({ open: false });
    }
  }

  handleKeyDown(event) {
    if (event.key === 'Escape') {
      this.setState({ open: false });
    }
  }

  render() {
    const { userName } = this.props;
    const displayName = userName || 'This user';

    return (
      <div className="profile-hero__verifiedWrap" ref={this.wrapperRef}>
        <button
          type="button"
          className="profile-hero__chip profile-hero__chip--verified"
          onClick={this.handleToggle}
          aria-expanded={this.state.open}
          aria-haspopup="dialog"
        >
          <Icon name="shield-check" size={18} color={primitives.violet['500']} />
          <span>Verified</span>
        </button>

        {this.state.open && (
          <div
            className="profile-hero__verifiedPopover"
            role="dialog"
            aria-label="Verified identity"
          >
            <p className="profile-hero__verifiedPopoverText">
              {displayName}&rsquo;s identity has been verified by Lexody.
            </p>
          </div>
        )}
      </div>
    );
  }
}

VerifiedChip.propTypes = {
  userName: PropTypes.string,
};

export default VerifiedChip;
